import React from 'react';
import {
  Button,
  Header,
  Icon,
  Modal,
  Input as SemanticInput,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import withKeyboard, {
  getValue,
} from 'Common/Components/Keyboard/withKeyboard';
import { LAYOUT_TYPES } from 'Common/Components/Keyboard/constants';
import { createToast, toastType } from 'Common/ToastHelper';
import { normalizeNumeric } from 'Common/FormHelper';
const KeyboardInput = withKeyboard(SemanticInput);

class InputDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    showDialog: PropTypes.bool.isRequired,
    onOkClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    initialText: PropTypes.string,
    // Keyboard props
    useKeyboard: PropTypes.bool,
    layoutType: PropTypes.string,
    focusOnMount: PropTypes.bool,
  };

  static defaultProps = {
    cancelText: 'Cancel',
    okText: 'Ok',
    type: 'text',
    useKeyboard: false,
    layoutType: LAYOUT_TYPES.DEFAULT,
    focusOnMount: false,
    initialText: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      text: props.initialText,
    };
  }

  submit = () => {
    const { text } = this.state;
    if (text && text.length > 0) {
      this.props.onOkClick(text);
    } else {
      createToast(toastType.error, 'Error', 'Please enter some text.');
    }
    this.reset();
  };
  cancel = () => {
    this.reset();
    this.props.onCancelClick();
  };

  reset = () => {
    this.setState({ text: '' });
  };

  render() {
    const {
      title,
      message,
      showDialog,
      maxLength,
      cancelText,
      okText,
      type,
      useKeyboard,
      layoutType = LAYOUT_TYPES.DEFAULT,
      focusOnMount,
    } = this.props;

    const { text } = this.state;

    const Input = useKeyboard ? KeyboardInput : SemanticInput;

    return (
      <Modal size="mini" open={showDialog}>
        <Header icon="info circle" content={title} />
        <Modal.Content>
          <strong>{message}</strong>
          <br />
          <br />
          <Input
            {...(maxLength ? { maxLength } : undefined)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                this.submit();
              }
              if (e.key === 'Escape') {
                this.cancel();
              }
            }}
            value={text}
            fluid
            type={type}
            onChange={(e, event) => {
              let value = useKeyboard ? getValue(e) : event.value;
              if (type === 'numeric') {
                value = normalizeNumeric(value);
              }
              this.setState({ text: value });
            }}
            {...useKeyboard && {
              usePortal: true,
              layoutType,
              focusOnMount,
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.cancel}>
            <Icon className="icon--white" name="cancel" />
            {cancelText}
          </Button>
          <Button primary onClick={this.submit}>
            <Icon className="icon--white" name="checkmark" />
            {okText}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export { InputDialog };



// WEBPACK FOOTER //
// ./src/components/dialogs/InputDialog.js